import { createSelector, Selector } from '@reduxjs/toolkit'
import { GlobalState } from '../store'
import { configurationStoreSelector } from './storeSelectors'
import { FeatureToggleConfig } from '../common'
import { isNumber } from 'lodash'

export const featureToggleConfigSelector: Selector<GlobalState, FeatureToggleConfig | null> = createSelector(
  configurationStoreSelector,
  configurationStore => configurationStore.featureToggles || null
)

export const heartbeatTimeoutSelector: Selector<GlobalState, number> = createSelector(configurationStoreSelector, configurationStore =>
  isNumber(configurationStore.heartbeatTimeoutMS) ? configurationStore.heartbeatTimeoutMS : 0
)
